import { FormControl } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledFormControl = styled(FormControl)(() => ({
  '& .MuiFormLabel-root.MuiInputLabel-root': {
    paddingLeft: 8,
    paddingRight: 8,
    backgroundImage: 'linear-gradient(to bottom, transparent 50%, #fff 50%)',
    color: '#666666',
    '&.Mui-disabled': {
      color: '#d2d4d7',
      WebkitTextFillColor: '#d2d4d7',
    },
  },
  '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#00b5e299 !important',
    borderWidth: 2,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderWidth: '1px',
    borderColor: 'rgba(0, 0, 0, 0.23)',
  },
}));
